/**
 * @file   src\utils\apiUrls.ts
 * @brief  This file is responsible for defining api methods.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

// Authorization api urls.
export enum AuthApi {
  LOGIN = '/user/signIn',
  FORGOT_PASSWORD = '',
  REFRESH_TOKEN = '/user/renewToken',
  LOGOUT = "/user/signOut",
  SEND_LOGIN_OTP = '',
  RESET_PASSWORD_TOKEN_VALIDATION = '',
  UPDATE_DEVICE_TOKEN = '/user/update-device-token'
}


export enum SettingsApi {
  GET_SETTINGS = '/company/getAppSettings/'
}

export enum BayApi {
  GET_BAYS = '/location/location-bays',
  GET_BAY_STATUS = '/location/bayStatus/',
  CHECK_WASHES_AVAILABLE = '/user/getUserSubscriptionStatus',
  GET_BAY_TYPES = '/location/getBayTypes',
  SELF_SERVE_START = '/location/startSelfServeWash',
  SELF_SERVE_STOP = '/location/stopSelfServeWash',
  GET_ACTIVE_WASH = '/user/getUserActiveWashDetails',
  SELF_SERVE_EXTEND = '/subscription/extentSingleWashTime'

}

// Signup api urls.
export enum SignupApi {
  SIGN_UP = '/user/appUserSignup',
  VARIFY = '/user/verify-otp',
  LOCATION_LIST = '/location/getLocations',
  RESEND_SIGN_UP_OTP = '',
  UPDATE_PHONE_NO = '/user/updateUserPhoneNumber',
  VALIDATE_REFERRAL_CODE = '/user/verify-referral',
  APPLY_FAMILY_CODE = '/user/updateUserAsChildFromSignup'
}

// Location fetch and update urls.
export enum LocationApi {
  LOCATION_FETCH = '/location/getLocations',
  LOCATION_UPDATE = '/user/updateDefaultLocation',
  SELECTED_LOCATION_DETAILS = '/user/user-selected-location',
}

// Subscription and washprice fetch and update urls.
export enum SubscriptionandwashpriceApi {
  Subscriptionandwashprice_FETCH = '/subscription/listing',
  PURCHASE_SUBSCIPTION = '/subscription/purchase-subscription',
  GET_SAVED_CARDS = '/subscription/list-saved-cards',
  TRAIL_CONSUMPTION_CHECKING = '/subscription/check-trial-period-consumed',
  CANCEL_SINGLE_WASH = '/subscription/cancel-single-wash',
  CHECK_FREE_WASH_AVAILABLE = '/subscription/check-free-wash-available',
  UNSUBSCRIBE_API = '/user/unsubscribeEmail',
  GET_SUBSCRIPTION_BY_ID = '/user/getUserSubscriptionDetails',
  CHECK_PARENT_HAS_SUBSCRIPTION = '/user/checkParentHasActiveSubscription',
  GET_PARENT_SAVED_CARDS='/subscription/parent/list-saved-cards',
  PURCHASE_BULK_WASH = "/subscription/purchase-bulk-wash",
  BUYUP_LISTING = '/subscription/buyup-listing',
  PURCHASE_BUYUP = '/subscription/purchase-buyup',
  PURCHASE_FREE_SINGLE_WASH = '/subscription/purchase-free-singlewash',
  GET_SUBSCRIPTION_BY_CODE = '/subscription/by-code/'
}

// Update Payment API urls.
export enum UpdatePaymentApi {
  GET_SAVED_CARDS_LIST= '/user/saved-card-details',
  UPDATE_CARD_DETAILS = '/user/update-card-details',
  DELETE_CARD_DETAILS = '/user/delete-payment-method',
}

// My profilee fetch and update urls.
export enum ProfileApi {
  PROFILE_FETCH = '/user/getUserProfile',
  PROFILE_UPDATE = '/user/updateUserProfile',
  MY_SUBSCRIPTIONS = '/user/getUserSubscription',
  CANCEL_SUBSCRIPTIONS = '/subscription/cancel-subscription',
  LOCATION_PAYMENT_METHOD = '/subscription/get-location-payment-method',
  USER_REFERRAL_FETCH = '/user/get-user-referral',
  USER_FAMILY_REFERRAL_FETCH = '/user/get-family-referral'
}

// User Api's.
export enum UserApi {
  CONTACT_US = '/user/contactOwner',
  NOTIFICATION_LIST = '/user/notifications',
  ADVERTISEMENT_LIST = '/user/getAdvertisement',
  UPDATE_USER_CAR_DETAILS = 'user/update-user-car-details',
  GET_USER_CAR_DETAILS = 'user/get-user-car-details',
  APPLY_FAMILY_CODE='/user/updateUserAsChild'
}


// User Api's.
export enum PromotionApi {
  PROMOTION_LIST = '/user/getPromotionsList',
  VALIDATE_COUPON_CODE = '/user/validate-discount-code',
}

// User Location Api's.
export enum UserlocationApi {
  LOCATION_CHECK = 'user/checkUserIsNearToLocation',
}

export enum GiftCardApi {
  PRODUCTS = '/giftCard/products',
  WALLET = '/giftCard/wallet',
  PURCHASE = '/giftCard/purchase',
  CLAIM_START = '/giftCard/claim/start',
  CLAIM_CONFIRM = '/giftCard/claim/confirm',
}